import React, { Component } from "react";
import { connect } from "react-redux";
import Dashboard from "../Components/Dashboard";

import {
  viewOldCarLength,
  viewTestDriveLength,
  viewContactUsLengths,
  viewAllVehicleEnq,
  viewAllService
} from "../action";
import { onLogout } from "../../Auth/Actions";
import { close_snack_bar } from "../../Common/snackbar/action";

const mapStateToProps = (state) => ({
  login: state.login,
  client: state.client,
  snackbar: state.snackbar,
});

const mapDispatchToProps = (dispatch) => ({
  viewOldCarLength: (token, user_id) => dispatch(viewOldCarLength(token, user_id)),
  viewTestDriveLength: (token, user_id) => dispatch(viewTestDriveLength(token, user_id)),
  viewContactUsLengths: (token, user_id) => dispatch(viewContactUsLengths(token, user_id)),
  viewAllVehicleEnq: (token, user_id, search, page, rowsPerPage) =>
    dispatch(viewAllVehicleEnq(token, user_id, search, page, rowsPerPage)),
  viewAllService: (token, user_id, search, page, rowsPerPage) =>
    dispatch(viewAllService(token, user_id, search, page, rowsPerPage)),
  close_snack_bar: () => dispatch(close_snack_bar()),
  onLogout: () => {
    /* logout logic if needed */
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
